'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n'], ['\n  display: inline-flex;\n  align-items: center;\n']);

var _icons = require('./icons');

Object.defineProperty(exports, 'icons', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_icons).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.span(_templateObject);

var Icon = function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'sizeToPx',
    value: function sizeToPx(size) {
      var sizeMapping = {
        xs: 8,
        s: 12,
        m: 16,
        md: 19,
        l: 26,
        xl: 32,
        xxl: 110
      };
      return size in sizeMapping ? sizeMapping[size] : 16;
    }
  }, {
    key: 'render',
    value: function render() {
      var size = this.sizeToPx(this.props.size);
      var name = this.props.name;

      var color = this.props.color ? this.props.color : this.props.theme.textColor;
      return _react2.default.createElement(
        Wrapper,
        { className: 'icon ' + this.props.className },
        _icons2.default[name](size, color)
      );
    }
  }]);

  return Icon;
}(_react.PureComponent);

Icon.propTypes = {
  size: _propTypes2.default.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']),
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  theme: _propTypes2.default.shape({
    textColor: _propTypes2.default.string.isRequired
  }).isRequired
};

Icon.defaultProps = {
  size: 'm',
  color: null,
  className: ''
};

exports.default = (0, _styledComponents.withTheme)(Icon);
Icon.__docgenInfo = [{
  'description': '',
  'displayName': 'Icon',
  'methods': [{
    'name': 'sizeToPx',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'size',
      'type': null
    }],
    'returns': null
  }],
  'props': {
    'size': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'xs\'',
          'computed': false
        }, {
          'value': '\'s\'',
          'computed': false
        }, {
          'value': '\'m\'',
          'computed': false
        }, {
          'value': '\'l\'',
          'computed': false
        }, {
          'value': '\'xl\'',
          'computed': false
        }, {
          'value': '\'xxl\'',
          'computed': false
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'m\'',
        'computed': false
      }
    },
    'color': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'name': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'theme': {
      'type': {
        'name': 'shape',
        'value': {
          'textColor': {
            'name': 'string',
            'required': true
          }
        }
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Icon/index.js'] = {
    name: 'Icon',
    docgenInfo: Icon.__docgenInfo,
    path: 'src/Icon/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Icon/index.js
// module id = 20
// module chunks = 1